import { Component, Inject, OnInit } from '@angular/core';
import { ApproachLighting, ApproachLightingType } from '../models/approach-lighting.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { RunwayService } from '../service/runway.service';
import { Obstacle } from '../models/obstacle.model';

@Component({
  selector: 'app-edit-area-lighting',
  templateUrl: './edit-area-lighting.component.html',
  styleUrls: ['./edit-area-lighting.component.scss']
})
export class EditAreaLightingComponent implements OnInit {
  lighting: ApproachLighting;
  origLighting: ApproachLighting;
  airportId: number;
  takeoffLandAreaId: number;
  isLoading = true;
  isNew = false;
  formGroup: FormGroup;
  selectedLightingType: string;

  constructor(private _matDialogRef: MatDialogRef<EditAreaLightingComponent>,
              public _snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) data,
              private _runwayService: RunwayService) {
    this.lighting = data.lighting || new ApproachLighting();
    this.isNew = data.isNew || false;
    this.origLighting = Object.assign(new ApproachLighting(), data.lighting);
    this.airportId = data.airportId;
    this.takeoffLandAreaId = data.takeoffLandAreaId;

    if (data.isNew) {
      this.selectedLightingType = '';
    } else {
      this.selectedLightingType = this.getSelectedLightingType(this.lighting.type);
    }
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      lightingType: new FormControl(this.selectedLightingType, [Validators.required]),
      description: new FormControl(this.lighting.description, [Validators.maxLength(4000)])
    });
    this.isLoading = false;
  }

  getSelectedLightingType(type: ApproachLightingType): string {
    return ApproachLighting.formatApproachLightingType(type);
  }

  setSelectedLightingType(type: string): ApproachLightingType {
    return ApproachLighting.parseApproachLightingType(type);
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let result: any;
      this.lighting.takeoffLandAreaId = this.takeoffLandAreaId;
      this.lighting.type = this.setSelectedLightingType(this.formGroup.value.lightingType);
      this.lighting.description = this.formGroup.value.description;

      if (this.isNew) {
        result = await this._runwayService.postLighting(this.airportId, this.lighting);
        this.lighting = ApproachLighting.parse(result);
      } else {
        result = await this._runwayService.putLighting(this.airportId, this.lighting);
        this.lighting = ApproachLighting.parse(result);
      }
      this.close({cancelBtnClicked: false, success: true, lighting: this.lighting});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false, error: e});
    }
  }


  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.lighting, this.origLighting);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }
}
